import ApiClient from '@daresay/api-client';

export const apiClient = new ApiClient({ credentials: 'include' });
